module.exports = __webpack_public_path__ + "img/introduce-icon.4ab0deb4.png";